import React from 'react'
import styles from './master-form.module.css'
import MoneySuperMarket from '../../../content/assets/money-super-market.svg'
import Switchd from '../../../content/assets/switchd.svg'
import MakeMyHouseGreen from '../../../content/assets/make-my-house-green.svg'
import { Affiliates } from '../../model/affiliates'
// import { randInt } from '../../utils/math'
// import { useStaticQuery, graphql } from 'gatsby'
// import Image from 'gatsby-image'

export const AffiliateType = {
  Energy: 'energy',
  Solar: 'solar'
}

const switchdWeighting = 1.00 // % chance of seeing this affiliate

const StepAffiliate = (props) => {
  switch (props.type) {
  case AffiliateType.Energy:
  default:
    // return renderRandomAffiliate()
    return renderWeightedEnergyAffiliate()
  case AffiliateType.Solar:
    return renderAffiliateSolar()
  }
}

const renderWeightedEnergyAffiliate = () => {
  if (Math.random() <= switchdWeighting) {
    return renderAffiliateSwitchd()
  }
  return renderAffiliateMSM()
}

// const renderRandomAffiliate = () => {
//   const numAffiliates = Object.entries(Affiliates.Awin.HomeEnergy).length
//   const randomAffiliate = Object.keys(Affiliates.Awin.HomeEnergy)[randInt(0, numAffiliates)]
//   switch (randomAffiliate) {
//   case 'MoneySuperMarket': return renderAffiliateMSM()
//   case 'Switchd': return renderAffiliateSwitchd()
//   default: return renderAffiliateMSM()
//   }
// }

const renderAffiliateMSM = () => {
  return (
    <div className={styles.affiliate}>
      <MoneySuperMarket className={styles.stepAffiliateImage} />
      <p className={styles.question}>We&apos;re partnered with MoneySuperMarket. Compare MoneySuperMarket’s best energy tariffs and switch in five minutes.</p>
      {renderButton(Affiliates.Awin.HomeEnergy.MoneySuperMarket, 'View Quotes')}
      {/* <p className={styles.affiliateSubText}>* Based on savings made by 30% of consumers that applied to switch via MoneySuperMarket, Aug ’20 – Jul ’21, with the estimated annual cost adjusted for the Oct ’21 Ofgem price cap. GB only.</p> */}
    </div>
  )
}

const renderAffiliateSolar = () => {
  return (
    <div className={styles.affiliate}>
      <MakeMyHouseGreen className={styles.stepAffiliateImage} />
      <p className={styles.question}><b>We&apos;re partnered with MakeMyHouseGreen.</b></p>
      <p className={styles.question}>They will show you the impact of different green products on your wallet and carbon footprint, and provide <b>free quotes for solar panel installation.</b></p>
      {renderButton(Affiliates.MakeMyHouseGreen, 'View Quotes')}
    </div>
  )
}

const renderAffiliateSwitchd = () => {
  return (
    <div className={styles.affiliate}>
      {/* {<Image className={styles.stepAffiliateImage} fluid={useAffiliateLogo().childImageSharp.sizes}/>} */}
      <Switchd className={styles.stepAffiliateImage} />
      <p className={styles.question}><b>We&apos;re partnered with Switchd, the auto switching energy service.</b></p>
      <p className={styles.question}>Save <b>£100s</b> each year as their impartial service searches the energy market every day, then automatically switches you to the best energy deals.</p>
      {renderButton(Affiliates.Switchd, 'Try Now For Free')}
      {/* <p className={styles.affiliateSubText}>* Average saving for Switchd UK residential customers 2017-2018.</p> */}
    </div>
  )
}

const renderButton = (link, label) => {
  return (
    // eslint-disable-next-line
    <a className={styles.buttonClearFormatting} href={link} target='_blank'>
      <button className={styles.button} type='button'>{label}</button>
    </a>
  )
}

// const useAffiliateLogo = () => {
//   const { logo } = useStaticQuery(
//     graphql`
//       query {
//         logo: file(absolutePath: { regex: "/switchd.jpg/" }) {
//           childImageSharp {
//             sizes(maxWidth: 400) {
//               ...GatsbyImageSharpSizes_noBase64
//             }
//           }
//         }
//       }
//     `
//   )
//   return logo
// }

export default StepAffiliate
